import React from 'react'


import { HEADER_MENU_TITLE_LINK } from '../../constants'
import { formatUrl } from '../../helperFunctions'

export const SOLUTIONS = [

  {
    head: HEADER_MENU_TITLE_LINK.solutions.audioVisual,
    bg: 'bg-sol-1',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.audioVisual),
    content: <React.Fragment>
      <h5 style={{ marginTop: '1rem' }}>Acoustic Treatment</h5>
      <p>For a room to be conducive for its sound operations, acoustic treatment is necessary before or after the construction of a room to optimize its acoustic behavior. Absorption and diffusion are the two primary elements to consider.</p>
      <p>With EIDIM’S experienced audio engineers, we provide the most suitable solutions and surface treatments that turn even the most cavernous warehouse or any types of room into a suitable acoustic environment.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.videoSignage,
    bg: 'bg-sol-8',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.videoSignage),
    content: <React.Fragment>
      <h5 style={{ marginTop: '1rem' }}>Digital Signage</h5>
      <p>An excellent company’s digital media system is a must. Digital signage allows a business to accomplish variety of goals.</p>
      <p>EIDIM’s digital media services are dedicated to simplify and manage the process of creating, selecting, implementing, and supporting solutions for digital signage. Our solutions are designed to help expand the reach of your marketing message to your targeted audience and dominate in your industry.</p>

      <h5 style={{ marginTop: '1rem' }}>Video Wall</h5>
      <p>Stadiums, command and control rooms, public large venues are the most common places video walls are found. Commonly used as advertising platform, video walls serve several purposes. With its superior versatility and reliability, it can withstand vibration, humidity and ambient light. Over years of operations, it will not require extensive maintenance which is highly optimal in the long run.</p>
      <p>EIDIM is committed to provide video wall system design and solutions that adheres to the systems’ purpose, functionality and operations.</p>

      <h5 style={{ marginTop: '1rem' }}>Projection</h5>
      <p>Whether it be for churches, schools, businesses, you name it. EIDIM has got you covered for your projection system’s needs for both system upgrade and new installation. Meeting our client’s system requirements is our priority, hence we ensure to gauge every aspects of the system in order to produce accurate design and implement cost‐effective solutions.</p>

      <h5 style={{ marginTop: '1rem' }}>Interactive smart boards and Displays</h5>
      <p>People tend to gravitate towards anything that is one swipe or click away. In today’s modern age, the immense transformation and innovation of technology reflect people’s desire to get things done instantly which paved the way for interactive smart boards and displays.</p>
      <p>The integration of interactive smart boards and displays to the daily operation of an institution or company has been a true game changer in allowing an even more efficient and productive environment thrive. We are here to cater the most up to date designs and integrations of interactive smart boards and displays to your workspace.</p>

    </React.Fragment>
  },

  {
    head: `${HEADER_MENU_TITLE_LINK.solutions.unifiedCommunication} / VTC`,
    bg: 'bg-sol-7',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.unifiedCommunication),
    content: <React.Fragment>
      <p>Effective, reliable and instant communication plays a vital role in company’s success. Unified communication and video conferencing require seamless integration of audio and visual technologies, it enables online conferences seem to be among participants in the same room.</p>
      <p>From EIDIM’s long history of expertise with all video conferencing and unified communications, we provide options every business requires to attain their desired collaboration systems that fits both company’s requirements and budget.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.controlSystem,
    bg: 'bg-sol-2',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.controlSystem),
    content: <React.Fragment>
      <p>You don’t need multiple remotes to control every device, leave it to the control and command system. Through this system, bringing multiple information materials in real‐time has never been more obtainable. It enables firms to have control over its environment all the time and provides a great effect in the management of daily operations.</p>
      <p>We believe that control and command system solutions, whether large‐scale or modest, has no value if the implementation and utilization are strenuous. Hence, EIDIM ensures that apart from designing and installation, we provide detailed training and broad customer support to our clients.</p>

    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.publicAddress,
    bg: 'bg-sol-4',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.publicAddress),
    content: <React.Fragment>

      <p>Who doesn’t want to be heard clearly and get their message across in any environment? We totally get it. EIDIM is here to back you up, our public address systems and solutions are designed to be powerful and meet your sound system needs.</p>
      <p>For your school, business, or any organization, our public address system solutions are implemented with versatility and offer a variety of multimedia options.</p>

    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.theatricalLighting,
    bg: 'bg-sol-6',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.theatricalLighting),
    content: <React.Fragment>
      <p>Studies show that quality of light affects people in several various ways. Overall satisfaction and productivity are achieved by well‐designed illumination as it enhances the mood and desirability of the area’s spaces.</p>
      <p>Through EIDIM’s cost‐control design and lighting solutions, we help clients realized that an investment to a professional lighting designer counterbalances by the reduction of operating costs.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.securitySurveillance,
    bg: 'bg-sol-5',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.securitySurveillance),
    content: <React.Fragment>
      <p>“Safety first” as the popular saying goes. No firm has ever overlooked the aspect of security and protection as one of the top priorities. Knowing the area is well secured and monitored, it boosts people’s confidence and trust towards an establishment.</p>
      <p>Security Surveillance System adds another layer of protection for your company. EIDIM is here to help you facilitate your security standards through modern and advanced security surveillance devices and equipment, which also comes with an in depth understanding of proper installation and implementation of the system.</p>
    </React.Fragment>
  },

  {
    head: HEADER_MENU_TITLE_LINK.solutions.hearingLoop,
    bg: 'bg-sol-3',
    order: 'flip',
    scrollId: formatUrl(HEADER_MENU_TITLE_LINK.solutions.hearingLoop),
    content: <React.Fragment>
      <p>We strive to make AV solution for everybody. This special type of sound system to accommodate people with special needs. With the use of the new technology, we can develop and support an excellent hearing loop system aids for the best possible hearing experience. EIDIM’s design, specification, and installation support our clients in developing a loop system that complies to the standard and would provide an optimal benefit to the end user.</p>
    </React.Fragment>
  },
]